import { RecurrenceInfo } from "./RecurrenceInfo";

export class AppointmentInfo {
  start: Date | null = null;
  end: Date | null = null;
  attendees: string[] = [];
  recurrence: RecurrenceInfo | null = null;

  constructor(initializer?: any) {
    if (!initializer) return;
    if (initializer.length > 0) this.start = initializer[0];
    if (initializer.length > 1) this.end = initializer[1];
    if (initializer.length > 2) this.attendees = initializer[2];
    if (initializer.length > 3) this.recurrence = initializer[3];
  }

  toUrlParams(): string {
    let params = "";
    if (this.start != null) {
      params += `&start=${this.start.toISOString()}`;
    }
    if (this.end != null) {
      params += `&end=${this.end.toISOString()}`;
    }
    if (this.attendees != null && this.attendees.length > 0) {
      params += `&attendees=${this.attendees}`;
    }
    if (this.recurrence != null) {
      params += this.recurrence.toUrlParams();
    }
    return params;
  }
}
